export const TABLE_CELL_STYLES =
  'border-secondary-border first:border-s last:border-e relative truncate border-b-[1px] py-3 px-6 text-sm group-last/row:first:rounded-bl-lg group-last/row:last:rounded-br-lg';
